module.exports = __webpack_public_path__ + "static/us-montreal.be21bb9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/us-montreal.jpg
// module id = 634
// module chunks = 35783957827783